export default __webpack_public_path__ + "static/media/trash.d14a548a.svg";